import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatTableDataSource } from '@angular/material/table';
import { RoleNames } from 'src/app/authentication/auth-helpers';
import { AccountHomeInfo } from 'src/app/model/account-home';
import { AppSubscription } from 'src/app/model/subscription';

@Component({
    selector: 'ms-account-list-table',
    templateUrl: './account-list-table.component.html',
    styleUrls: ['./account-list-table.component.scss'],
})
export class AccountListTableComponent implements OnInit {
    @Input() accountFound: boolean;
    @Input() dataSourceAccounts: MatTableDataSource<AccountHomeInfo> = new MatTableDataSource<AccountHomeInfo>();
    @Input() model: AppSubscription;
    @Input() searchAccountText: string;
    @Input() showFilterOptions: boolean;
    @Input() notChoosingListOfAccounts: boolean;
    @Input() minDate: Date;
    @Input() userAdmins: string[];
    @Output() applyAccountSearch = new EventEmitter<any>();
    @Output() showAssociateAccount = new EventEmitter();
    @Output() doSomething = new EventEmitter<any>();
    @Output() changeBackground = new EventEmitter<any>();
    @Output() removeRow = new EventEmitter<string>();
    @Output() setAccountName = new EventEmitter<AccountHomeInfo>();
    @Output() setListAccounts = new EventEmitter<AccountHomeInfo[]>();
    @Output() setDate = new EventEmitter<Date>();

    selection = new SelectionModel<AccountHomeInfo>(true, []);
    displayedColumnsAccounts: string[] = ['AccountName'];
    value: Date;

    constructor() {}

    ngOnInit(): void {}

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSourceAccounts.data.length;
        return numSelected === numRows;
    }

    //Cliccando su seleziona tutti gli account
    masterToggle() {
        if (this.isAllSelected()) {
            this.selection.clear();
            this.setListAccounts.emit(this.selection.selected);
            return;
        }
        if (this.value) {
            this.dateOnChange();
        }
        this.selection.select(...this.dataSourceAccounts.data);
        this.setListAccounts.emit(this.selection.selected);
    }

    //Impostando la data di scadenza associazione per tutti gli account
    dateOnChange() {
        this.setDate.emit(this.value);
        this.dataSourceAccounts.data.map((x) => (x.ExpirationDateSubscription = this.value));
    }

    //Impostando la data di scadenza associazione per il singolo account
    singleDateOnChange(row: AccountHomeInfo) {
        this.setDate.emit(this.dataSourceAccounts.data.filter((x) => x.AccountName === row.AccountName)[0].ExpirationDateSubscription);
    }

    onClick(event: Event) {
        event.stopPropagation();
    }

    //Selezionando le checkbox per il singolo account
    onChange(event: MatCheckboxChange, row: AccountHomeInfo) {
        if (event) {
            this.selection.toggle(row);
            this.setListAccounts.emit(this.selection.selected);
        } else {
            return null;
        }
    }

    clearAccountSearch() {
        this.searchAccountText = '';
        this.dataSourceAccounts.filter = this.searchAccountText.trim().toLowerCase();
        this.accountFound = true;
        this.showFilterOptions = true;
    }

    onClickShowAssociateAccount() {
        this.showAssociateAccount.emit();
    }

    onClickApplyAccountSearch(event: any) {
        if (this.notChoosingListOfAccounts) {
            this.applyAccountSearch.emit(event);
        } else {
            let filterValue: string;
            filterValue = (event.target as HTMLInputElement).value;
            this.dataSourceAccounts.filter = filterValue.trim().toLowerCase();
        }
    }

    onClickDoSomething(event: any) {
        this.doSomething.emit(event);
    }

    onClickChangeBackground(event: any) {
        this.changeBackground.emit(event);
    }

    onClickRemoveRow(event: string) {
        this.removeRow.emit(event);
    }

    onClickSetAccountName(event: AccountHomeInfo) {
        this.setAccountName.emit(event);
    }
    showTrash(accountName: string) {
        if (this.userAdmins?.length == 1 && this.userAdmins.findIndex((x) => x == accountName) == 0) return false;
        else return true;
    }
}
